import { PageData } from 'api/Pagination/Types'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'

import {
  CampaignResultsExportItem,
  CampaignResultsItem,
  CampaignResultsProvider,
  FetchParams,
} from './CampaignResultsProvider'

export class MarketingCampaignResultsProvider implements CampaignResultsProvider {
  supportsSort = true
  constructor(
    private api: TradingAccountsApiClient,
    private campaignId: string,
    private campaignTypeId: number
  ) {}

  async fetch(params: FetchParams): Promise<PageData<CampaignResultsItem[]>> {
    return this.api.getMarketingCampaignResults(this.campaignId, this.campaignTypeId, params)
  }

  mapExport(items: CampaignResultsItem[]): CampaignResultsExportItem[] {
    return items.map((result: CampaignResultsItem) => {
      if ('ranking' in result && result.ranking === -1) {
        return { ...result, ranking: 'N/A' }
      }
      return result
    })
  }
}
